import { render, staticRenderFns } from "./AdvertisedEndpointsCard.vue?vue&type=template&id=3bdd69da"
import script from "./AdvertisedEndpointsCard.vue?vue&type=script&lang=js"
export * from "./AdvertisedEndpointsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports